import { render, staticRenderFns } from "./EditNikudPane.vue?vue&type=template&id=2b7ca1b9&scoped=true&"
import script from "./EditNikudPane.vue?vue&type=script&lang=js&"
export * from "./EditNikudPane.vue?vue&type=script&lang=js&"
import style0 from "./EditNikudPane.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditNikudPane.vue?vue&type=style&index=1&id=2b7ca1b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ca1b9",
  null
  
)

export default component.exports